import angular from 'angular';
/**
 * Filtro para utilizar el lang de laravel en angular.
 * Utiliza la librería https://github.com/andywer/laravel-js-localization
 * Uso
 *      get: {{ 'clave' | lang }}
 *      choice: {{ 'clave' | lang:1 }}
 */
export default function LangFilter() {
    return function (key, metodo, param1, param2) {
        var numero = null;
        var replacements = {};

        var procesaReplacements = function (replacements) {
            angular.forEach(replacements, function (value, key) {
                var cadenasSeparadas = value.split(';');
                var cadenasProcesadas = [];
                angular.forEach(cadenasSeparadas, function (value, key) {
                    var newValue = null;
                    var langDividido = value.split(':');

                    if (langDividido[1] == 'get') {
                        newValue = Lang.get(langDividido[0])
                    } else if (langDividido[1] == 'choice') {
                        if (langDividido.length < 2 && typeof parseInt(langDividido[2]) !== 'number')
                            throw console.error("El segundo parámetro del filtro lang tiene que ser un núemro");
                        newValue = Lang.choice(langDividido[0], parseInt(langDividido[2]));
                    } else {
                        throw console.error("El primer argumento del filtro debe ser get o choice");
                    }
                    this.push(newValue);
                }, cadenasProcesadas);

                this[key] = cadenasProcesadas.join(' ');
            }, replacements);

            return replacements;
        };

        if (typeof key !== 'string')
            throw console.error("El filtro lang solo se puede utilizar para cadenas de texto");

        if (metodo === 'get') {
            replacements = param1;
            replacements = procesaReplacements(replacements);
            return Lang.get(key, replacements);
        } else if (metodo === 'choice') {
            numero = param1;
            replacements = param2;
            replacements = procesaReplacements(replacements);
            if (typeof numero !== 'number')
                throw console.error("El segundo parámetro del filtro lang tiene que ser un núemro");
            return Lang.choice(key, numero, replacements);
        } else {
            throw console.error("El primer argumento del filtro debe ser get o choice");
        }
    };
}